module.exports = __webpack_public_path__ + "img/Logo_wh.42b55165.svg";